import { combineReducers } from 'redux';
import eventsModule from 'Redux/eventsModule/reducer';
import hierarchyModule from 'Redux/hierarchyModule/reducer';
import monitoringEventFormModule from 'Redux/monitoringEventFormModule/slice';
import monitoringEventModule from 'Redux/monitoringEventModule/slice';
import monitoringModelEntityModule from 'Redux/monitoringModelEntityModule/slice';
import monitoringModule from 'Redux/monitoringModule/reducer';
import monitoringMultiModelEntitiesModule from 'Redux/monitoringMultiModelEntitiesModule/slice';
import monitoringSearchEventModule from 'Redux/monitoringSearchEventModule/slice';
import monitoringSearchModelModule from 'Redux/monitoringSearchModelModule/slice';
import monitoringTooltipModule from 'Redux/monitoringTooltipModule/reducer';
export default combineReducers({
    eventsModule,
    monitoringEventModule,
    monitoringModule,
    hierarchyModule,
    monitoringTooltipModule,
    monitoringEventFormModule,
    monitoringModelEntityModule,
    monitoringMultiModelEntitiesModule,
    monitoringSearchEventModule,
    monitoringSearchModelModule
});
